/**
 * 开放应用
 */
export default {
  //构建内容
  build() {
    return [
      {
        title: 'prod-app-word',//文档资料
        content: [{
          name: 'prod-whaee-word-navigation',//品沃科技-哇鹅文档导航
          id: 1,
          link: 'https://nsksiwszvz.feishu.cn/docx/doxcnDXRte0fs7Y6WzI7ROo0aSd',
          logoColor: '#CCCCCC',
          img: require('@/assets/logo/whaee_word.png')
        },{
          name: 'prod-whaee-data-analyze-navigation',//品沃科技-产研数据分析
          id: 2,
          link: 'https://nsksiwszvz.feishu.cn/docx/doxcnAXvmm3BdXYZxvIV2Vs8xze',
          logoColor: '#66b1ff78',
          img: require('@/assets/logo/whaee_data_analyze.png'),
          isDeveloper: true
        }]
      },
      {
        title: 'prod-app-work',//办公
        content: [{
          name: 'prod-app-sevens-office',//Sevens Office
          id: 1,
          link: 'http://quickconnect.cn/sevensnas',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/sevens_office_logo.png')
        }]
      },
      {
        title: 'app-officialWebsite',//"官方网站",
        content: [{
          name: 'prod-app-sevens',//sevens主页
          id: 1,
          link: 'https://www.sevensmarketing.com',
          logoColor: '#444444',
          img: require('@/assets/logo/sevens_logo.png')
        }, {
          name: 'prod-app-pingworth',//品沃主页
          id: 2,
          link: 'https://pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/pingworth_logo.jpg')
        }, {
          name: 'prod-app-store',//'哇鹅-商家端',
          id: 3,
          link: 'https://www.whaee.com',
          logoColor: '#EC5830',
          img: require('@/assets/logo/whaeeLogo.png')
        }, {
          name: 'prod-app-sensation',//'哇鹅-红人端',
          id: 4,
          link: 'https://www.whatsworth.com',
          logoColor: '#FF3D48',
          img: require('@/assets/logo/pingworth.png')
        }]
      },
      {
        title: 'app-businessSystem',//业务系统
        content: [{
          name: 'prod-app-whaee-operator',//哇鹅-商家端 - Sevens运营账户入口
          id: 1,
          link: 'https://console.whaee.com/v2/operator/login',
          logoColor: '#EC5830',
          img: require('@/assets/logo/whaeeLogo.png')
        }, {
          name: 'prod-app-mms',//MMS
          id: 2,
          link: 'https://mms.pingworth.com',
          logoColor: '#3f48cc',
          img: require('@/assets/logo/mmsLogo.png')
        }, {
          name: 'prod-app-kpa',//KPA
          id: 3,
          link: 'https://kpa.pingworth.com',
          logoColor: '#7e40c7',
          img: require('@/assets/logo/kpaLogo.png')
        }, {
          name: 'prod-app-cs',//CS
          id: 4,
          link: 'https://cs.pingworth.com',
          logoColor: '#A349A4',
          img: require('@/assets/logo/csLogo.png')
        }, {
          name: 'prod-app-fms',//FMS
          id: 5,
          link: 'https://fms.pingworth.com',
          logoColor: '#57000d',
          img: require('@/assets/logo/fmsLogo.png')
        }, {
          name: 'prod-app-dms',//DMS
          id: 6,
          link: 'https://dms.pingworth.com',
          logoColor: '#518217',
          img: require('@/assets/logo/dmsLogo.png')
        }, {
          name: 'prod-pw-os',//品沃OS
          id: 7,
          link: 'https://os.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/pw_os_logo.png'),
          isDeveloper: true
        }]
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/content/content_prod_app.js